import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router';

import Header from './index';
import { scrollToContact } from '../../modules/home/actions';
import { NavButtonContact, NavButtonHome } from './styles';

const InscriptionHeader = ({ scrollToContact, history }) => {
	const { t } = useTranslation();

	return (
		<Header>
			<NavButtonHome
				content={t('general.menu.home')}
				onClick={() => history.push('/')}
			/>
			<NavButtonContact
				className={'contact-button'}
				content={t('general.menu.contact')}
				onClick={scrollToContact}
			/>
		</Header>
	);
};

const mapDispatchToProps = dispatch => {
	return {
		scrollToContact: payload => scrollToContact(dispatch, payload)
	};
};

export default connect(null, mapDispatchToProps)(withRouter(InscriptionHeader));
